// extracted by mini-css-extract-plugin
export default {"addSpecialLeave":"SpecialLeave_addSpecialLeave__adJfP","customFileUpload":"SpecialLeave_customFileUpload__bL2uO"};